<div
*ngIf="!basicAndNeedsDiagnosticExamFirst && curriculumDataReceived && !justDemo"
class="outer-container">

  <div fxLayout="column">
      <div>

        <div class="sub-title left">{{curriculumViewData?.HBFullName}}</div>

        <div class="right mb-15" fxLayout="row">

          <button *ngIf="curriculumViewData?.IsTeacher"
          class="button secondary-button"
          (click)="confirmLoginDialog()">Login As {{curriculumViewData?.StudentFullName}}
          </button>

          <button 
          *ngIf="!curriculumViewData?.HasLessonMax"
          class="button secondary-button ml-15" (click)="navigateStandardsGrowthReport()">
            Standard Achievements
          </button>
        </div>

      </div>

      <div fxLayout="row" fxLayoutAlign="end" class="exp-col-cont">
        <span 
          class="exp-col" 
          [class.collapse-all]="showAll"
          [class.expand-all]="!showAll"
          (click)="onExpandCollapseAll()">
          {{showAll ? 'Collapse All' : 'Expand All'}}
        </span>
      </div>
  </div>

  <div class="cards"> 

    <div 
    class="card"
      *ngFor="let unit of curriculumViewData?.Groups | orderBy: 'Sequence'; let i = index">

      <div class="unit-card-header"> 

              <div 
                fxLayout="row"
                fxLayoutAlign="space-between center"
                (click)="expandCollapseUnit(unit)">

                    <div class="unit-title">
                      <b>{{ unit?.GroupName }}</b>
                    </div>

                    <div fxLayout="row" fxLayout="center center" class="unit-header-right-side">

                      <div class="unit-suggested-count" 
                      *ngIf="unit.Hide && countSuggestedItems(unit) > 0"
                      fxLayout="row" fxLayoutAlign="end center"
                      >
                        {{countSuggestedItems(unit)}} Suggested
                      </div>

                      <div>
                        <mat-icon 
                        class="exp-col-icon"
                        *ngIf="unit.Hide" 
                          style="color: #3e5aa0;" >
                          expand_less
                        </mat-icon>

                        <mat-icon 
                        class="exp-col-icon"
                        *ngIf="!unit.Hide" 
                        style="color: #3e5aa0;">expand_more</mat-icon> 
                      </div>
                      
                    </div>

              </div>

              <hr>
              
      </div>

      <div *ngIf="!unit.Hide">
          <div>

              <div class="lessons" fxLayout="row wrap" fxLayoutAlign="start">

                <div 
                  *ngFor="let lesson of unit?.Items | orderBy: 'Sequence'; let j = index"
                  fxLayout="column"
                  [class.lesson-card]="!lesson.IsFormativeAssessment"
                  [class.lesson-card-assessment]="lesson.IsFormativeAssessment">

                  <div 
                    *ngIf="lesson.IsFormativeAssessment && lesson.Sequence != 1"
                  class="diag-badge">
                    Unit Test
                  </div>

                  <div 
                    *ngIf="lesson.Suggested && !lesson.CompletedWithProficiency"
                  class="suggested">
                    Suggested
                  </div>

                  <div 
                    *ngIf="lesson.Suggested && lesson.CompletedWithProficiency"
                  class="suggested-complete">
                    Suggested <i class="fas fa-check"></i> 
                  </div>

                  <div 
                    *ngIf="!lesson.Suggested && lesson.CompletedWithProficiency"
                  class="suggested-complete">
                    <i class="fas fa-check"></i> 
                  </div>
                  
                  <div class="lesson-card-header" [ngStyle]="{
                    'background': 'linear-gradient(180deg, rgba(0,0,0,1) 0%, rgba(255,255,255,.5) 100%),  
                      url(' + imagePath + lesson.ImagePath + ')',
                    'background-size': '100%',
                    'background-position': '0% 35%'
                  }"
                  >{{ lesson?.LessonName }}</div>

                  <div class="lesson-card-middle" fxLayout="column" fxLayoutAlign="center center">

                    <div
                    class="status">
                      {{lesson?.CanStart ? 'Not Started' : lesson?.CanContinue ? 'In Progress' : lesson?.CanRetake ? '' : ''}}
                    </div>

                    <div 
                    *ngIf="lesson?.LessonGrade"
                    class="lesson-grade"
                    [class.lesson-grade-bad]="lesson.Suggested && lesson.CanRetake && !lesson.CompletedWithProficiency"
                     >
                        {{lesson?.LessonGrade}}%
                    </div>

                  </div>

                  <div class="lesson-card-bottom">

                    <div class="buttons" fxLayout="row" fxLayoutAlign="space-around center">

                      <div class="left-button">

                        <button
                          class="button  card-button"
                          [class.primary-button]="(lesson?.CanStart && lesson?.Suggested) || lesson?.CanContinue || (lesson?.CanRetake && lesson?.Suggested && !lesson.CompletedWithProficiency)"
                          [class.secondary-button]="(lesson?.CanRetake && lesson.Suggested && lesson.CompletedWithProficiency) || (lesson?.CanStart && !lesson?.Suggested) || (lesson.CanRetake && !lesson.Suggested)"
                          *ngIf="!curriculumViewData?.IsTeacher && ( (curriculumViewData?.HasLessonMax && unit.Sequence > 0) || (!curriculumViewData?.HasLessonMax) )"
                          (click)="redirectToExternalLink(lesson, $event)">
                          {{lesson?.CanStart ? 'Start' : lesson?.CanContinue ? 'Continue' : lesson?.CanRetake ? 'Re-Take' : ''}}   
                        </button>
      
                        <button
                          class="button primary-button card-button"
                          [disabled]="!lesson?.HasCompletedAttempt || (!curriculumViewData?.IsTeacher && unit.Sequence == 0 && curriculumViewData?.HasLessonMax)"
                          *ngIf="curriculumViewData?.IsTeacher || (!curriculumViewData?.IsTeacher && unit.Sequence == 0 && curriculumViewData?.HasLessonMax)"
                          (click)="redirectToViewWork(lesson, $event)">
                          View Work
                        </button>
                      </div>

                      <div class="right-button">
                        <button 
                        class="button secondary-button card-button"
                        (click)="openDetailsDialog(lesson)">
                          Details
                        </button>
                      </div>

                    </div>


                  </div>

                </div>
                
              </div>            

            </div>
      </div>
      
    </div>

  </div>

</div>

<div 
    *ngIf="basicAndNeedsDiagnosticExamFirst && curriculumDataReceived && !justDemo"
    class="outer-container"
    fxLayout="column" fxLayoutAlign="center center"> 
    <div class="sub-title left">{{curriculumViewData?.HBFullName}}</div>
      <span *ngIf="this.curriculumViewData.HasDemoCompleted">
        Prior to accessing your recommended lessons, {{curriculumViewData?.IsTeacher ? 'your student ' : 'you '}} must complete the full diagnostic exam.
      </span>
      <span *ngIf="!this.curriculumViewData.HasDemoCompleted">
        Prior to accessing your recommended lessons, {{curriculumViewData?.IsTeacher ? 'your student ' : 'you '}} must complete the full diagnostic exam.
      </span>

      <div>
        <button 
        class="mar-top button secondary-button"
        (click)="confirmLoginDemoDialog($event)"
        >
        {{curriculumViewData?.IsTeacher ? 'Log in as ' +  curriculumViewData.StudentFullName + ' and': ''}}
        {{this.curriculumViewData.HasDemoCompleted ? "Continue " : "Start "}}  Pre-diagnostic Exam
        </button>
      </div>
</div>

<div
  *ngIf="curriculumDataReceived && justDemo"
  class="outer-container"
  fxLayout="column" fxLayoutAlign="center center">

  <div class="sub-title left">{{curriculumViewData?.HBFullName}}</div>

  <span *ngIf="this.curriculumViewData.HasDemoCompleted">
    View {{curriculumViewData?.IsTeacher ? "your student's " : 'your '}} free diagnostic report. 
  </span>

  <span *ngIf="!this.curriculumViewData.HasDemoCompleted">
    {{curriculumViewData?.IsTeacher ? 'Your student needs to continue ' : 'Continue '}} the free diagnostic exam.
  </span>

  <div>
    <button 
    *ngIf="this.curriculumViewData.HasDemoCompleted"
      class="mar-top secondary-button button"
      [routerLink]="['/ELearning/CurriculumDiagnosticFeatures/' + this.curriculumViewData.StudentID + '/' + this.curriculumViewData.HBClassID]"
      
      >
      View {{curriculumViewData?.IsTeacher ? curriculumViewData.StudentFullName + "'s ": 'your '}} free diagnostic report.
    </button>

    <button 
    *ngIf="!this.curriculumViewData.HasDemoCompleted"
      class="mar-top secondary-button button"
      (click)="confirmLoginDemoDialog($event)"
      >
      {{curriculumViewData?.IsTeacher ? 'Log in as ' +  curriculumViewData.StudentFullName + ' and continue': 'Continue'}}
       the free diagnostic exam
    </button>
  </div>

</div>

<div *ngIf="!curriculumDataReceived" class="spinner-wrapper">
  <div fxLayout="column">
    <mat-spinner [diameter]="50" mode="indeterminate"></mat-spinner>
    <div *ngIf="loginAsStudentSpinner">Logging in as {{curriculumViewData.StudentFullName}}</div>
  </div>
</div>
